import * as navigation from 'Navigation';

export default class MoleculePredictedPropertiesTabState extends navigation.TabState {
  override defaults(): navigation.TabStateDefaults {
    return {
      ...super.defaults(),
      title: 'ADMET Predictions',
      closeable: false,
      preferenceKey: 'molecule-admet-predictions',
    };
  }
}
